export const environment = {
  production: false,
  baseUrl: 'https://albo-umbria.synergica.tech/albo-api',
  printUrl: 'https://albo-umbria.synergica.tech/print-api',
  keycloakUrl: 'https://auth3.synergica.tech',
  civilianextUrl: '',
  moduliUrl: 'http://localhost:8084/moduli-api',
  domandeUrl: 'http://localhost:8083/domande-api',
  regione: 'umbria',
  realm: 'umbria',
  clientId: 'albo-web',
  importIscritti: false,
  stampeDelibere: false,
  gestioneDomande: true,
  regioniAnaliticaInformazioniIscritti: false,
  sollecito: true,
  alboRole: false,
  mezzoPagamentoDomanda: 6,
  multiLingua: false,
  //dashboard
  cards: [
    {id: 1, type: 'provvisori', value: 0},
    {id: 2, type: 'morosità', value: 0},
    {id: 3, type: 'trasferimento', value: 0},
    {id: 4, type: 'sospesi', value: 0}
  ],
  labelRegionale: 'Umbria'
};
